/* Elvaire: one-click add to cart for the "Complete the look" upsell (product page and cart drawer) */
window.evAddToCart = function (variantId, box) {
  const cart = document.querySelector('cart-drawer');
  const msg = box && box.querySelector('.ev-quick__msg, .ev-upsell__msg');
  const body = { items: [{ id: Number(variantId), quantity: 1 }] };
  if (cart && cart.getSectionsToRender) {
    body.sections = cart.getSectionsToRender().map((s) => s.id);
    body.sections_url = window.location.pathname;
  }
  if (box) box.classList.add('is-busy');
  return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  })
    .then((r) => r.json())
    .then((res) => {
      if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
      if (cart && cart.renderContents) {
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(res);
      } else {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }
    })
    .catch(() => { if (msg) msg.textContent = document.documentElement.lang === 'en' ? 'Something went wrong, please try again.' : 'Une erreur est survenue, réessayez.'; })
    .finally(() => { if (box) box.classList.remove('is-busy'); });
};
if (!window.evUpsellBound) {
  window.evUpsellBound = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ev-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const item = btn.closest('[data-ev-upsell-item]');
    const select = item.querySelector('[data-ev-upsell-variant]');
    window.evAddToCart(select.value, item);
  });
}
